import { LegalEntityEnum, LocalizedString, OrderType } from '@onrunning/backstage-models';
import { globalConstants } from '../constants/global.constants';

export const localeMixins = {
  getSupportedLocaleLanguage(locale: string) {
    const getValidLocale = (language: string) => {
      // at the time all available locales on the shared LocalizedString class are the only valid locale languages,
      // if you want to add a new locale language please modify the class on cil libs and update the lib here as well as on backstage-api
      for (const validLanguage in new LocalizedString()) {
        if (validLanguage.startsWith(language)) {
          return validLanguage;
        }
      }
    };

    let validLanguage = getValidLocale(locale);

    if (!validLanguage) {
      const langCountry = locale.split('-');

      validLanguage = getValidLocale(langCountry[0]);
    }

    return validLanguage ?? globalConstants.defaultLocale;
  },

  getLocaleTextByOrderType(parentObjectKey: string, orderType: OrderType, legalEntity: LegalEntityEnum) {
    if (orderType === OrderType.StockClearance) {
      const title = parentObjectKey + orderType.toLocaleLowerCase() + `.${legalEntity.toLocaleLowerCase()}`;
      return title;
    } else {
      return parentObjectKey + orderType.toLocaleLowerCase();
    }
  },
};
